<template>
  <div
    id="wizard-steps"
    class="scene flex-r size-100"
    style="position:fixed; top:0; left:0; min-height: auto; height: 100%;"
  >
    <div class="section size-10" />

    <div class="section size-30">
      <h1>
        Заполните несколько форм и присоединитесь
        к будущему уже сегодня:
      </h1>

      <div class="signup-wizard">
        <WizardStepItem
          v-for="step in steps"
          :key="step.number"
          :step="step"
          :selected-step-number="selectedStep.number"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WizardStepItem from './WizardStepsItem';

export default {
  name: 'WizardSteps',
  components: {
    WizardStepItem
  },
  props: {
    steps: {
      type: Array,
      required: true
    },
    selectedStep: {
      type: Object,
      required: true
    }
  }
}
</script>
